import React, { FC, ReactNode } from 'react'
import { SxProps } from '@mui/material'
import { Box } from '@mui/material'
import { flexColumn } from '../../utils/MUIShortcuts'

const container: SxProps = {
  ...flexColumn('center', 'space-evenly'),
  width: '90%',
  maxWidth: '440px',
  background: '#fff',
  height: 'auto',
  minHeight: '20vh',
  padding: '16px',
  boxShadow: '0px 3px 9px rgba(0, 0, 0, .15)',
  borderRadius: '2px'
}

type MCBaseProps = {
  children?: ReactNode
}

const MCBase = ({children}:MCBaseProps) => {
  return (
    <Box sx={container}>
      {children}
    </Box>
  )
}

export default MCBase